import { create } from 'zustand'


const useStore = create((set) => ({

    mp: [],
    setMp: (mp) => set({ mp }),
    addMp: (newMp) => set((state) => ({ mp: [...state.mp, newMp] })),
    
    postcode: '',
    setPostcode: (postcode) => set({ postcode }),

    userEmail: '',
    setUserEmail: (userEmail) => set({ userEmail }),
    
    fullname: '',
    setFullname: (fullname) => set({fullname}),

    message: '',
    setMessage: (message) => set({ message }),
    
    cc: false,
    setCc: (cc) => set({ cc }),

    isFormValid: false,
    setIsFormValid: (email, mp, fullname, token) => set({ isFormValid: !!(email !== '' && mp.length > 0 && fullname !== '' && token !== '') }),

    initialText: "",
    setInitialText: (initialText) => set({initialText}),

    closingText: "",
    setClosingText: (closingText) => set({closingText}),

    combinedText: "",
    setCombinedText: (combinedText) => set({combinedText}),

    token: "",
    setToken: (token) => set({token}),

}))

export default useStore 